<template>
	<article class="c-frontpage-card" :class="`c-frontpage-card--${color}`">
		<a v-if="link && link.url" :href="link.url" :target="link.target">
			<div class="p-box-padding pb-[40px] flex flex-col items-center">
				<div v-if="$slots.icon" class="c-frontpage-card__icon">
					<slot name="icon"></slot>
				</div>
				<div class="pb-[20px]">
					<h2
						v-if="title"
						class="text-22 leading-none font-bold text-center"
					>
						{{ title }}
					</h2>
					<p v-if="text" class="text-center mt-[10px]">{{ text }}</p>
				</div>
				<div
					class="c-frontpage-card__action"
					:class="[
						{
							'bg-cyan-dark': color === 'cyan',
							'bg-blue-dark': color === 'blue',
							'bg-purple-dark': color === 'purple',
						},
					]"
				>
					<SvgIconWedge class="w-[13px] h-[13px] fill-white" />
				</div>
			</div>
		</a>
	</article>
</template>

<script setup>
import SvgIconWedge from '~/assets/svgs/icon-wedge.svg';

defineProps({
	link: Object,
	text: String,
	title: String,
	color: String,
});
</script>

<style lang="postcss">
.c-frontpage-card {
	@apply relative;
	transition: transform 0.3s;

	svg {
		transition: transform 0.3s;
	}
}
.c-frontpage-card__action {
	height: 40px;
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
}
.c-frontpage-card__icon {
	@apply flex justify-center items-center;
	border-radius: 10px;
	border: 3px solid #fff;
	width: 100px;
	height: 100px;
	position: relative;
	margin: 0 auto 20px;
	transition: -webkit-transform 0.3s;
	transition: transform 0.3s;
}
.c-frontpage-card:hover {
	transform: scale(1.05);

	.c-frontpage-card__icon {
		transform: scale(1.05);
	}
	svg {
		transform: scale(1.15);
	}
}

.c-frontpage-card--cyan {
	@apply bg-cyan;
	background-image: linear-gradient(#046c72, #05868e);
}
.c-frontpage-card--blue {
	@apply bg-blue;
	background-image: linear-gradient(#224274, #2c5697);
}
.c-frontpage-card--purple {
	@apply bg-purple;
	background-image: linear-gradient(#622074, #77278d);
}
</style>
